module.exports = __webpack_public_path__ + "img/enroll-a-generator.0e0fa3fb.svg";